<template>
  <section>
    <v-row>
      <v-col
        cols="12" sm="6" lg="3"
        v-for="(item, index) in cartas"
        :key="index"
      >
        <v-card rounded="xl" elevation="3" class="kpi-card">
          <v-card-text class="pa-4">
            <div class="d-flex align-center">
              <!-- Icono en caja coloreada (inline, sin position absolute) -->
              <div
                :class="[item.color, 'kpi-icon rounded-xl d-flex align-center justify-center flex-shrink-0 mr-4']"
              >
                <v-icon color="white" size="26">{{ item.icono }}</v-icon>
              </div>
              <!-- Datos a la derecha -->
              <div class="flex-grow-1 text-right">
                <div class="text-caption text--secondary text-uppercase font-weight-bold">
                  {{ item.nombre }}
                </div>
                <div class="text-h5 font-weight-black text--primary mt-1">
                  {{ item.total }}
                </div>
              </div>
            </div>
          </v-card-text>
          <v-divider />
          <v-card-text class="pa-2 px-4 d-flex align-center" style="min-height:36px;">
            <v-icon x-small class="mr-1 text--secondary">mdi-clock-outline</v-icon>
            <span class="text-caption text--secondary">{{ item.subtitulo || 'Hasta hoy' }}</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: 'CartasPersonalizadas',
  props: ['cartas'],
}
</script>

<style scoped>
.kpi-card {
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.kpi-card:hover {
  transform: translateY(-2px);
}
.kpi-icon {
  width: 52px;
  height: 52px;
  min-width: 52px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogos/CartasPersonalizadas.vue